import { render, staticRenderFns } from "./core_paragraph.vue?vue&type=template&id=221adfb3&scoped=true"
import script from "./core_paragraph.vue?vue&type=script&lang=js"
export * from "./core_paragraph.vue?vue&type=script&lang=js"
import style0 from "./core_paragraph.vue?vue&type=style&index=0&id=221adfb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221adfb3",
  null
  
)

export default component.exports